import React from 'react';
import DesignUsageExample from './design-usage-example';
import ActionImage from 'shared/img/aptitude/action.svg';
import SupportImage from 'shared/img/aptitude/support.svg';
import ActionAndSupportImage from 'shared/img/aptitude/action-and-support.svg';

const DesignUsage = () => (
  <>
    <h2>Design Usage Types</h2>
    <DesignUsageExample
      image={<ActionImage width={181} />}
      title="Triggering Actions"
      description={`Icons are used for interactions, i.e., dropdown menu
                    triggers, checks in checkboxes, removing pills, etc.`}
      examples={['Removable pills', 'Info icons', 'Close modal']}
    />
    <DesignUsageExample
      image={<SupportImage width={119} />}
      title="Supporting Labels"
      description={`Icons can be used to reinforce a label or differentiate
                    a group of labels from one another. They are often seen
                    to the left of a label, but not always.`}
      examples={[
        'Quick stats cards',
        'Student profile contact information',
        'High school name in portfolio',
        'Starred popular majors',
      ]}
    />
    <DesignUsageExample
      image={<ActionAndSupportImage width={218} />}
      title="Labels and Action Icons"
      description="Sometimes a component uses both a supporting icon and an interactive icon."
      examples={['Search bar with clear form ability']}
    />
  </>
);

export default DesignUsage;
